import Immutable from 'immutable'
import moment from 'moment'
import { createSelector } from 'reselect'

import createHmac from '../../records/Hmac'
import createToken from '../../records/Token'
import createUser from '../../records/User'

// ------------------------------------
// Constants
// ------------------------------------
export const CLEAR = 'inf/auth/CLEAR'
export const HANDLE_LOGIN = 'inf/auth/HANDLE_LOGIN'
export const LOGIN = 'inf/auth/LOGIN'
export const LOGOUT = 'inf/auth/LOGOUT'
export const RECEIVE_CREDENTIALS = 'inf/auth/RECEIVE_CREDENTIALS'
export const REQUIRES_AUTHENTICATION = 'inf/auth/REQUIRES_AUTHENTICATION'
export const REFRESH_CREDENTIALS = 'inf/auth/REFRESH_CREDENTIALS'
export const TIMEOUT = 'inf/auth/TIMEOUT'

export const constants = {
  CLEAR,
  HANDLE_LOGIN,
  LOGIN,
  LOGOUT,
  RECEIVE_CREDENTIALS,
  REQUIRES_AUTHENTICATION,
  REFRESH_CREDENTIALS,
  TIMEOUT,
}

// ------------------------------------
// Actions
// ------------------------------------
export const clear = () => ({
  type: CLEAR,
})
export const handleLogin = location => ({
  payload: { location },
  type: HANDLE_LOGIN,
})
export const login = (token, returnTo) => ({
  payload: { returnTo, token },
  type: LOGIN,
})
export const logout = () => ({
  type: LOGOUT,
})
export const receiveCredentials = (user, hmac) => ({
  payload: { hmac, user },
  type: RECEIVE_CREDENTIALS,
})
export const requiresAuthentication = returnTo => ({
  payload: { returnTo },
  type: REQUIRES_AUTHENTICATION,
})
export const refreshCredentials = () => ({
  type: REFRESH_CREDENTIALS,
})
export const timeout = () => ({
  type: TIMEOUT,
})

export const actions = {
  clear,
  handleLogin,
  login,
  logout,
  receiveCredentials,
  requiresAuthentication,
  refreshCredentials,
  timeout,
}

// ------------------------------------
// Selector
// ------------------------------------
// Note: this is intended to replace selectAuthenticatedClientIds but
// selects state with an absolute key and isnt api compatible.
export const makeSelectAuthenticatedClientIds = () => createSelector(
  state => state.authentication.get('user'),
  user => (user
      ? user.get('relationships').map(r => r.get('client_id'))
      : Immutable.Set()
  ),
)

export const selectAuthenticatedPartnerClientIds = createSelector(
  state => state.authentication.getIn(['user', 'relationships'], Immutable.Set()),
  relationships => relationships
    .filter(r => r.roles.includes('PARTNER'))
    .map(r => r.client_id),
)

export const selectAuthenticatedClientIds = createSelector(
  state => state.get('user'),
  user => (user
    ? user.get('relationships').map(r => r.get('client_id'))
    : Immutable.Set()
  ),
)

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  authenticated: false,
  hmac: null,
  timedOut: false,
  token: null,
  user: null,
})

export default function reducer(state = initialState, { payload, type }) {
  switch (type) {
    case CLEAR:
    case LOGOUT:
      return initialState

    case LOGIN:
      return initialState.merge({
        authenticated: true,
        token: createToken(payload.token),
      })

    case RECEIVE_CREDENTIALS:
      state = state.set('hmac', createHmac({
        ...payload.hmac,
        expires: payload.hmac.expires ? moment(payload.hmac.expires) : null,
      }))
      if (payload.user) {
        state = state.set('user', createUser(payload.user))
      }

      return state
        .set('authenticated', true)
        .set('timedOut', false)

    case TIMEOUT:
      return initialState
        .set('timedOut', true)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/authentication.js